import { request } from '../../helpers'

export default {
  async listContent({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'content',
        queryParameters,
        expand,
      })
    ).data
  },
  async retrieveContent(id, { queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: `content/${id}`,
        queryParameters,
        expand,
      })
    ).data
  },
  async listContentCollections({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'content_collections',
        queryParameters,
        expand,
      })
    ).data
  },
  async retrieveContentCollection(id, { queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: `content_collections/${id}`,
        queryParameters,
        expand,
      })
    ).data
  },
  async addContentToFavorites(id, { data = {} }) {
    if (!id) {
      console.warn('API: addContentToFavorites id is not defined!')
      return
    }
    return await request({
      method: 'POST',
      url: `content/${id}/add_favorite`,
      data,
    }).data
  },
  async removeContentFromFavorites(id, { data = {} }) {
    if (!id) {
      console.warn('API: removeContentFromFavorites id is not defined!')
      return
    }
    return (
      await request({
        method: 'POST',
        url: `content/${id}/remove_favorite`,
        data,
      })
    ).data
  },
  async generateContentAccessLink(id, { data = {} }) {
    if (!id) {
      console.warn('API: generateAccessLink id is not defined!')
      return
    }
    return (
      await request({
        method: 'POST',
        url: `content/${id}/generate_access_link`,
        data,
      })
    ).data
  },
  async retrieveContentFilters({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        method: 'GET',
        url: 'content_filters',
        queryParameters,
        expand,
      })
    ).data
  },
}
